// angular
import { NgOptimizedImage } from '@angular/common';
import { Component, input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
// interfaces
import { ITender } from '@tenders/shared/interfaces/tender.interface';
// pipes
import { ImageSourcePipe } from '@app/shared/pipes/image-source.pipe';
import { TranslateDataPipe } from '@app/shared/pipes/translate-data.pipe';

@Component({
  selector: 'pwj-tender-info-card',
  standalone: true,
  imports: [
    NgOptimizedImage,
    TranslateModule,
    TranslateDataPipe,
    ImageSourcePipe,
  ],
  templateUrl: './tender-info-card.component.html',
  styleUrl: './tender-info-card.component.scss',
})
export class TenderInfoCardComponent {
  tender = input.required<ITender>();
}
